// extracted by mini-css-extract-plugin
export default {"additionalContent":"Dialog_additionalContent__8nHtG","title":"Dialog_title__JDuGr","message":"Dialog_message__9moY1","actionsCont":"Dialog_actionsCont__fSBWU"};